<template>
  <section class="o-fairListing" :class="{ purple }">
    <modal :id="modalId">
      <h2>{{ modalTitle }}</h2>
      <v-select
        :placeholder="$t('components.fairListing.modal.select.placeholder')"
        :items="fairOptions.sort((a,b) => {
          if (a.label.toLowerCase() < b.label.toLowerCase()) {
            return -1;
          }
          if (a.label.toLowerCase() > b.label.toLowerCase()) {
            return 1;
          }
          return 0;
        })"
        single-line
        menu-props="auto"
        outlined
        @input="registerFair"
        v-model="selectedFair"
        item-text="label"
        item-value="code"

      ></v-select>
    </modal>
    <div class="o-container o-container--xlarge">
      <h1 class="u-centered">
        {{ title }}<span v-if="filteredList.length > 0">{{ titleSuffix }}</span>
      </h1>
      <div class="o-fairListing__list">
        <card-action v-if="!purple" @click.native="showModal" flair="new" />
        <card-fair
          v-for="fair in filteredList.slice(0, fairsToShow)"
          :key="fair.booth.regiNr"
          :title="fair.displayName"
          :displaytext="fair.booth.blendentext"
          :code="fair._id"
          :location="fair.booth.halleBezeichnung"
          :place-num="fair.booth.standnummer"
          :area="fair.booth.flaecheBrutto"
          :state="fair.booth.status"
          :source="fair.source"
          :renew="fair.booth.status === 'OP'"
          :renew-info="fair.renewInfo"
          :route="{
            name: 'FairDetail',
            params: { code: fair.idCode, booth: fair.booth.regiNr }
          }"
          :is-exhibitor="fair.booth.ausstellerTyp === 'AUSSTELLER'"
          :is-distributor="fair.booth.ausstellerTyp === 'VERTRAGSHAENDLER'"
        />
      </div>
      <div class="u-centered">
        <bos-button
          @click="showAll()"
          v-if="fairsToShow !== Infinity && filteredList.length > originalFairsToShow"
          >{{ $t('components.fairListing.active.showAll') }}
          <template #icon>
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 20" width="21" height="20">
              <g id="Layer 1">
                <path id="Layer" fill-rule="evenodd" class="s0" d="m20.5 4.5h-7.1l-2.9 5.4-3-5.4h-7l6.3 11h7.4l6.3-11z"/>
              </g>
            </svg>
          </template>
          </bos-button
        >
        <bos-button
          ghost
          :color="'ghost'"
          @click="showLess()"
          v-if="fairsToShow === Infinity"
          >{{ $t('components.fairListing.active.showLess') }}
          <template #icon>
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" width="34" height="34">
              <g id="Layer 1">
                <path id="Layer" fill-rule="evenodd" class="s0" d="m0.5 22.5h7.1l2.9-5.4 3 5.4h7l-6.3-11h-7.4z"/>
              </g>
            </svg>
          </template>
          </bos-button>
      </div>
    </div>
  </section>
</template>

<script>
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'
import CardFair from './CardFair'
import BosButton from './BosButton'
import CardAction from './CardAction'
import Modal from '@/components/Modal'
import ApiService from '../services/ApiService'

export default {
  name: 'BosFairListing',
  components: { CardAction, BosButton, CardFair, Modal },
  props: {
    title: {
      type: String,
      default: ''
    },
    titleSuffix: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    modalId: {
      type: [String, Number],
      required: true
    },
    modalTitle: {
      type: String,
      required: true
    },
    purple: Boolean
  },
  data() {
    return {
      selectedFair: null,
      fairsToShow: 5,
      originalFairsToShow: 5,
    }
  },
  computed: {
    filteredList() {
      const now = new Date()
      return this.list.filter(item => new Date(item.registrationDeadline) >= now || item.booth.status !== 'OP')
    },
    fairOptions() {
      let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)
      return localize(
        this.$store.getters['fair/getOneShopFairs'].filter(item => {
          const startTime = new Date(item.publish.start)
          const endTime = new Date(item.publish.end)
          endTime.setUTCHours(23)
          endTime.setUTCMinutes(59)
          endTime.setUTCSeconds(59)
          endTime.setUTCMilliseconds(999)
          const registrationDeadlineTime = new Date(item.registrationDeadline)
          registrationDeadlineTime.setUTCHours(0)
          registrationDeadlineTime.setUTCMinutes(0)
          registrationDeadlineTime.setUTCSeconds(0)
          registrationDeadlineTime.setUTCMilliseconds(0)
          const now = new Date()
          return startTime <= now && endTime >= now && registrationDeadlineTime >= now
        }),
        inAndExcludes.include,
        inAndExcludes.exclude
      ).map(fair => ({ label: fair.displayName, code: fair.idCode }))
    }
  },
  methods: {
    showAll() {
      this.fairsToShow = Infinity
    },
    showLess() {
      this.fairsToShow = this.originalFairsToShow
    },
    showModal() {
      this.$root.$emit(`modal:${this.modalId}:show`)
    },
    registerFair() {
      if (this.selectedFair) {
        this.$store.commit('ui/setModalStatus', false)
        this.$router.push({
          name: 'FairDetail',
          params: {
            code: this.selectedFair,
            booth: 'new'
          }
        })
      }
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.o-fairListing {
  background-color: transparent;
  margin: 4.5rem 0;

  .o-fairListing__list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 2.25rem;
    justify-content: center;

    > div {
      margin: 2.25rem;

      @media (max-width: 770px) {
        width: 100%;
        min-width: 294px;
      }
    }

    @media (max-width: 720px) {
      justify-content: center;
    }
  }

  &.purple {
    background-color: #635971;
    color: #f7f6f3;
  }
}

</style>
<style lang="scss">
  @media (max-width: 770px) {
    .modal-body {
      ul.vs__dropdown-menu {
        max-height: 125px !important;
      }
    }
  }

</style>
